var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-badge',{staticClass:"notice-area",attrs:{"is-dot":""}},[_c('icon',{attrs:{"name":"notice","scale":2.8}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }